import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { REVIEWS_MAIN_PAGE_PATH } from "utils/constants/paths";

const ReviewsMainPage = Loadable(React.lazy(() => import("./View")));

export const ReviewsMainPageRoute: IRouteItem = {
  path: REVIEWS_MAIN_PAGE_PATH,
  element: React.createElement(ReviewsMainPage),
  name: "Reviews Main Page",
};
